module.exports = __webpack_public_path__ + "83bc83dbf1dbaf61e7ceac91fc4ddd98.svg";